import { differenceInDays } from 'date-fns/differenceInDays';
import { parse } from 'date-fns/parse';
import { PRICELINE_DATE_FORMAT } from '../../constants/dates';
function getLengthOfStay(startDate, endDate) {
  if (startDate && endDate) {
    const difference = differenceInDays(parse(endDate, PRICELINE_DATE_FORMAT, new Date()), parse(startDate, PRICELINE_DATE_FORMAT, new Date()));
    return `(${difference} ${difference === 1 ? 'night' : 'nights'})`;
  }
  return '';
}
export default getLengthOfStay;